module.exports = __webpack_public_path__ + "img/img_ryytn_brand.e9240cf5.png";